export enum FEATURE_FLAGS {
    ActiveAgentsLanguageRoleFilters = "active_agents_language_role_filters",
    BrandEmailContentTemplateEdit = "brand_email_content_template_edit",
    BrandVariables = "brand_variables",
    EmailAccountSendTestEmail = "email_account_send_test_email",
    HandleQueryButton = "handle_query_button",
    LogicFlowContent = "logic_flow_content",
}
